export enum UserColumn {
  Name = 'name',
  Email = 'email',
  Customer = 'customer',
  Partner = 'partner',
  Role = 'role',
  Activity = 'activity',
  Actions = 'actions',
}

export namespace UserColumn {
  export const allColumns: string[] = [
    UserColumn.Name,
    UserColumn.Email,
    UserColumn.Customer,
    UserColumn.Partner,
    UserColumn.Role,
    UserColumn.Activity,
    UserColumn.Actions,
  ];

  export const displayedColumns: string[] = [
    UserColumn.Name,
    UserColumn.Email,
    UserColumn.Customer,
    UserColumn.Role,
    UserColumn.Activity,
    UserColumn.Actions,
  ];
  export const displayedAdminColumns: string[] = [
    UserColumn.Name,
    UserColumn.Email,
    UserColumn.Customer,
    UserColumn.Partner,
    UserColumn.Role,
    UserColumn.Activity,
    UserColumn.Actions,
  ];

  export const translateKey = (column: string): string => {
    switch (column) {
      case UserColumn.Name:
        return 'users.columns.name';
      case UserColumn.Email:
        return 'users.columns.email';
      case UserColumn.Customer:
        return 'users.columns.customer';
      case UserColumn.Partner:
        return 'users.columns.partner';
      case UserColumn.Role:
        return 'users.columns.role';
      case UserColumn.Activity:
        return 'users.columns.activity';
      case UserColumn.Actions:
        return 'users.columns.actions';
      default:
        return '';
    }
  };

  export const sortField = (column: string): string => {
    switch (column) {
      case UserColumn.Name:
        return 'name';
      case UserColumn.Email:
        return 'email';
      case UserColumn.Customer:
        return 'customer';
      case UserColumn.Partner:
        return 'partner';
      case UserColumn.Role:
        return 'role';
      case UserColumn.Activity:
        return 'active';
      default:
        return '';
    }
  };

  export const filter = (columns: string[]): string[] => {
    return columns.filter((column) => allColumns.includes(column));
  };
}
